const HomeIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.4567 2.83929L20.4592 7.50821C21.4334 8.26602 22.0033 9.43101 22.0037 10.6652V18.0025C22.0037 20.2123 20.2123 22.0038 18.0025 22.0038H5.99747C3.78764 22.0038 1.99622 20.2123 1.99622 18.0025V10.6655C1.99659 9.43132 2.56653 8.26604 3.5407 7.50824L9.5432 2.83929C10.9882 1.71527 13.0118 1.71527 14.4567 2.83929ZM13.2287 4.4179C12.506 3.8557 11.4939 3.8557 10.7712 4.4179L4.7687 9.08685C4.28156 9.46581 3.9965 10.0484 3.99622 10.6655V18.0025C3.99622 19.1078 4.89221 20.0038 5.99747 20.0038H18.0025C19.1077 20.0038 20.0037 19.1078 20.0037 18.0025V10.6658C20.0034 10.0486 19.7184 9.46581 19.2312 9.08685L13.2287 4.4179ZM7.99997 11.5C7.99997 11.2239 8.29845 11 8.66664 11H15.3333C15.7015 11 16 11.2239 16 11.5V12.5C16 12.7761 15.7015 13 15.3333 13H8.66664C8.29845 13 7.99997 12.7761 7.99997 12.5V11.5ZM8.66664 15C8.29845 15 7.99997 15.2239 7.99997 15.5V16.5C7.99997 16.7761 8.29845 17 8.66664 17H15.3333C15.7015 17 16 16.7761 16 16.5V15.5C16 15.2239 15.7015 15 15.3333 15H8.66664Z"
			fill="currentColor"
		/>
	</svg>
)

export default HomeIcon
